import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=0870259e"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"
import style0 from "./Login.vue?vue&type=style&index=0&id=0870259e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports